// Libs
import React from 'react';
import { useSelector } from 'react-redux';

// Components
import BottomHeader from 'COMPONENTS/BottomHeader';
import TopHeader from 'COMPONENTS/TopHeader';

// Utils
import { DIAGNOSTICS_PAGE, NARROW_LAYOUT, SUMMARY_PAGE } from 'UTILS/constants';

const Header = () => {
  const isSmallScreen = useSelector(state => state.app.layout === NARROW_LAYOUT);
  const shouldShowHeader = useSelector(state => [DIAGNOSTICS_PAGE, SUMMARY_PAGE].includes(state.nav.currentPage)) || !isSmallScreen;

  return (
    <div>
      {!isSmallScreen && (
        <TopHeader />
      )}
      {shouldShowHeader && (
        <BottomHeader />
      )}
    </div>
  );
};

export default Header;
